import React from "react";
import { Outlet } from "react-router-dom";
import NavBar from "../../components/Navbar/NavBar";
import SideBar from "../../components/Sidebar/SideBar";
import DashboardLayout from "../../layouts/DashboardLayout";
import { motion } from "framer-motion";

const Main = () => {
  return (
    <>
      <NavBar />
      <SideBar />
      <motion.div
        className="pt-16 sl:pt-24 pl-[var(--sidebar-width)] p-4 min-h-screen"
        animate={{
          paddingLeft: window.innerWidth >= 1024 ? `var(--sidebar-width)` : "0",
          transition: { type: "spring", stiffness: 300 },
        }}
      >
        <DashboardLayout>
          <motion.div
            animate={{
              paddingLeft: "1rem",
              transition: { type: "spring", stiffness: 300 },
            }}
          >
            <Outlet />
          </motion.div>
        </DashboardLayout>
      </motion.div>
    </>
  );
};

// const Main = () => {
//   return (
//     <>
//       <SideBar />
//       <NavBar />
//       <div className="pt-[93px] lg:ml-[var(--sidebar-width)] p-4 w-[var(--navbar-width)]">
//         <Outlet />
//       </div>
//     </>
//   );
// };

export default Main;
